import { IResourceDto } from "@models/storage/ResourceDto";
import { apiStorageToDto } from "@utils/helpers/gcp.helper";
import axios, { AxiosProgressEvent } from "axios";

let previousBytesUploaded = 0;

export type OnUploadedBytes = (uploadedBytes: number) => void;

const putStorageService = (
  url: string,
  file: File,
  onUploadedBytes?: OnUploadedBytes
) => {
  previousBytesUploaded = 0;
  return axios<IResourceDto>({
    url,
    method: "put",
    headers: {
      "Content-Type": file.type,
    },
    data: file,
    onUploadProgress: (progressEvent: AxiosProgressEvent) => {
      if (!onUploadedBytes || !progressEvent.total) {
        return;
      }

      const bytesUploadedSinceLastCall =
        progressEvent.loaded - previousBytesUploaded;
      previousBytesUploaded = progressEvent.loaded;

      onUploadedBytes(bytesUploadedSinceLastCall);
    },
    transformResponse: () => apiStorageToDto(url),
  });
};

export default putStorageService;
